export const behaviorQs = [
    'Does your dog have any destructive habits when left alone?',
    'Has your dog ever jumped, climbed, or dug out of a fence?',
    'Does your dog ever guard toys, food, water, or people?',
    'Has your dog ever socialized in a group of 6 or more dogs?',
    'Does your dog have experience in a kennel environment?',
    'Is there anything else we should know about their behavior?'
]

export const healthQs = [
    'Does your pet have any food allergies or sensitvites?',
    'Does your pet have any medical conditions or disabilities that we should know about?', 
    '(ex: Seizures, tumors, hot spots, etc.)',
    'Does your pet have any past injuries that we should know about?',
    'Is there anything else we should know about your pet’s health or medical history?'
]

export const petInfoQs = [
    'Sex',
    'Spayed or Neutered'
]